// API Base URL configuration
const getApiBaseUrl = () => {
  // Production'da API subdomain kullan
  if (process.env.NODE_ENV === 'production') {
    return 'https://api.sobcof.com';
  }
  
  // Development'da localhost kullan
  return 'http://localhost:8000';
};

export const API_BASE_URL = getApiBaseUrl();

// API endpoints
export const API_ENDPOINTS = {
  // Auth
  LOGIN: '/api/admin/login',
  VERIFY: '/api/admin/me',
  LOGOUT: '/api/admin/logout',
  
  // Users
  USERS: '/api/users',
  USER_STATS: '/api/users/stats/overview',
  USER_BAN: '/api/users/:id/ban',
  USER_UNBAN: '/api/users/:id/unban',
  
  // Dashboard
  DASHBOARD_STATS: '/api/dashboard/comprehensive-stats',
  USER_GROWTH: '/api/analytics/user-growth',
  MATCH_STATS: '/api/matches/stats',
  ANALYTICS_OVERVIEW: '/api/analytics/overview',
  
  // Matches
  MATCHES: '/api/matches',
  
  // Chats
  CHATS: '/api/chats',
  
  // Reports
  REPORTS: '/api/reports',
  REPORT_STATUS: '/api/reports/:id/status',
  
  // Locations
  LOCATIONS: '/api/locations',
  CITY_STATS: '/api/locations/city-stats',
  
  // Contacts
  CONTACTS: '/api/contacts',
  CONTACT_STATS: '/api/contact-stats',
  CONTACT_STATUS: '/api/contacts/:id/status',
  
  // Admins
  ADMINS: '/api/admins',
  
  // Notifications
  NOTIFICATION_TEMPLATES: '/api/notifications/templates',
  NOTIFICATION_FILTER_OPTIONS: '/api/notifications/filter-options',
  NOTIFICATION_STATS: '/api/notifications/stats',
  NOTIFICATION_HISTORY: '/api/notifications/history',
  NOTIFICATION_SCHEDULED: '/api/notifications/scheduled',
  NOTIFICATION_SCHEDULE: '/api/notifications/schedule',
  NOTIFICATION_SEND_USER: '/api/notifications/send-to-user',
  NOTIFICATION_SEND_ALL: '/api/notifications/send-to-all',
  NOTIFICATION_SEND_FILTERED: '/api/notifications/send-filtered',
  NOTIFICATION_DELETE: '/api/notifications/scheduled/:id',
  
  // Firebase Data
  FIREBASE_DATA: '/api/:endpoint',
  
  // Linktree
  LINKTREE_PUBLIC: '/api/public/links',
  LINKTREE_ADMIN: '/api/admin/links',
  LINKTREE_UPLOAD: '/api/admin/links/upload-logo',
} as const;

// URL builder helper
export const buildApiUrl = (endpoint: string, params?: Record<string, string | number>) => {
  let url = `${API_BASE_URL}${endpoint}`;
  
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      url = url.replace(`:${key}`, String(value));
    });
  }
  
  return url;
};
